import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { EmailHistoryTableService } from "../email-history-table.service";
import { ChartDataSets, ChartOptions,ChartType } from 'chart.js';
import { Color, BaseChartDirective, Label } from 'ng2-charts';

const moment = require('moment');

@Component({
  selector: 'contenido',
  templateUrl: './contenido.component.html',
  styleUrls: ['./contenido.component.scss']
})
export class ContenidoComponent implements OnInit {

  comunicacionMenu: any;
  @Input() statusMenu: Observable<any>;
  @Input() productoElegido: Observable<any>;

  @Output() abreMenu: EventEmitter<any> = new EventEmitter();
  @Output() abreDetalles: EventEmitter<any> = new EventEmitter();

  infoEmpresaProducto: Subject<any> = new Subject<any>();
  setStatusBoton: Subject<any> = new Subject<any>();
  infoSurveyCheck: Subject<any> = new Subject<any>();

  menuVisible = false;
  detallesVisible = true;
  productoActual: any;
  // fechasProducto = [
  //   { fecha: new Date('1/1/16'), tipo: 'Fecha de lanzamiento' },
  //   { fecha: new Date('1/1/21'), tipo: 'Fecha de cierre' },
  // ];
  datosDetallesProducto: any = {
    producto: 0,
    anio: 2000,
    fechasProducto: [
      { fecha: new Date('1/1/16'), tipo: 'lanzamiento', activa: true },
      { fecha: new Date('1/1/21'), tipo: 'cierre', activa: true },
      { fecha: new Date('1/1/21'), tipo: 'prorroga', activa: false },
    ],
    fechasProrrogas: {
      activas: false,
      ultima: new Date(),
      valorDatePicker: new Date()
    },
    progreso: {
      actual: 0,
      total: 0,
      porcentaje: 0
    },
    diasRestantes: 0,
    urlEncuesta: ''
  };
  idEmpresa: string;
  anioProducto: number;
  encuestaActiva: boolean = true;
  statusEncuesta: number;
  datosSurveyCheck: any;

  filtroLanzamiento: any;
  filtroCierreProrroga: any;


  constructor(
    private activatedRoute : ActivatedRoute,
    private surveyServ: EmailHistoryTableService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
    });
  }

  ngOnInit() {
    this.comunicacionMenu = this.statusMenu.subscribe( (datos:any) => {
      if(datos != null){
        console.log("statusMenu:",datos);
        this.menuVisible = datos.menu != null ? datos.menu : this.menuVisible;
        this.detallesVisible = datos.detalles != null ? datos.detalles : this.detallesVisible;
        if(datos.fijar != undefined){
          this.detallesVisible = true;
        }
      }
    });

    this.productoElegido.subscribe((datos:any) => {
      if (datos != null) {
        console.log("productoEnviado:",datos);
        this.productoActual = datos;
        this.obtieneDatosProducto();
        this.setTipoProducto();
      }
    })
  }

  setDatosDetalle(producto:number, anio:number, fechaInicio:string, fechaFin:string, fechaProrroga:string, prog_actual:number, prog_total:number){
    let hoy = moment();
    let fechaElegida = moment(fechaFin);
    let diffDias: number;
    if(hoy.isAfter(fechaElegida)){
      diffDias = 0;
    } else{
      diffDias = fechaElegida.diff(hoy,'days');
    }
    let porcentaje = (100 / prog_total) * prog_actual;
    let refDetalle = this.datosDetallesProducto;
    // console.log("refDet:",JSON.parse(JSON.stringify(refDetalle)));
    this.datosDetallesProducto = {
      producto: producto != null ? producto : refDetalle.producto,
      anio: anio != null ? anio : refDetalle.anio,
      fechasProducto: [
        { fecha: fechaInicio != null ? new Date(fechaInicio) : new Date(refDetalle.fechasProducto[0].fecha), tipo: 'lanzamiento', activa: true },
        {
          fecha: fechaFin != null ? new Date(fechaFin) : new Date(refDetalle.fechasProducto[1].fecha),
          tipo: 'cierre',
          activa: fechaProrroga != null || refDetalle.fechasProducto[2].activa == true ? false : true
        },
        {
          fecha: fechaProrroga != null ? new Date(fechaProrroga) : new Date(refDetalle.fechasProducto[2].fecha),
          tipo: 'prorroga',
          activa: fechaProrroga != null || refDetalle.fechasProducto[2].activa == true ? true : false
        },
      ],
      fechasProrrogas: refDetalle.fechasProrrogas,
      progreso: {
        actual: prog_actual != null ? prog_actual : refDetalle.progreso.actual,
        total: prog_total != null ? prog_total : refDetalle.progreso.total,
        porcentaje: prog_actual != null && prog_total != null ? porcentaje : refDetalle.progreso.porcentaje,
      },
      diasRestantes: fechaInicio != null && fechaFin != null ? diffDias : refDetalle.diasRestantes,
      urlEncuesta: refDetalle.urlEncuesta
    };
  }

  setTipoProducto(){
    let idProducto = this.productoActual.idProducto != undefined ? this.productoActual.idProducto : this.productoActual.idProduct;
    switch (idProducto) {
      //productos certificar
      case 1: localStorage.setItem('tipoProducto', '1'); break;
      case 20: localStorage.setItem('tipoProducto', 'c1'); break;
      case 40: localStorage.setItem('tipoProducto', 'c3'); break;
      //productos medir
      case 2: localStorage.setItem('tipoProducto', '2'); break;
      case 11: localStorage.setItem('tipoProducto', 'm1'); break;
      case 12: localStorage.setItem('tipoProducto', 'm2'); break;
      case 13: localStorage.setItem('tipoProducto', 'm3'); break;
      case 14: localStorage.setItem('tipoProducto', 'm4'); break;
      case 15: localStorage.setItem('tipoProducto', 'm5'); break;
      case 16: localStorage.setItem('tipoProducto', 'm6'); break;
      case 41: localStorage.setItem('tipoProducto', 'm7'); break;
      //productos pulse check
      case 4: localStorage.setItem('tipoProducto', '3'); break;
      case 42: localStorage.setItem('tipoProducto', 'p1'); break;
      //producto focus area
      case 43: localStorage.setItem('tipoProducto', 'f1'); break;
      //producto nom 35
      case 3: localStorage.setItem('tipoProducto', '5'); break;
      //producto cgo express
      case 52: localStorage.setItem('tipoProducto', 'CGOX'); break;
    }
  }

  obtieneDatosProducto(){
    let idProducto = this.productoActual.idProducto != undefined ? this.productoActual.idProducto : this.productoActual.idProduct;
    //variables de localstorage que ocupa el portal de conteos
    localStorage.setItem('Surveystaus_portal', 'activo');
    localStorage.setItem('idEmpresa_surveysatus', this.idEmpresa);
    localStorage.setItem('companyID', this.idEmpresa);
    localStorage.setItem('productoID', this.obtieneIdProductoCorrecto());
    localStorage.setItem('fechaProducto', this.obtieneFechaProductoCorrecta());
    this.getProrrogasFechasCierre(idProducto);
    if(this.productoActual.idSurvey != undefined || idProducto == 43){
      // this.getBanderaUpdateFechaCierre();
      this.obtieneToken();
      switch (idProducto) {
        case 3: //nom35
          this.getFechaLanzamientoNorma(this.productoActual.fechaNorma35);
          if(this.productoActual.idSurveyMas){
            this.getPorcentajeN35(this.productoActual.fechaNorma35, 0);
          } else if(this.productoActual.idSurveyMenos){
            this.getPorcentajeN35(this.productoActual.fechaNorma35, 1);
          }
        break;
        case 43: //focus area
          let dataInfo: any = { productoId: idProducto };
          this.surveyServ.getMostrarEncuestas(dataInfo, this.idEmpresa).subscribe((respuesta:any) => {
            console.log("getMostrarEncuestas:",respuesta);
            // let idFocus:any;
            // for(let i=0; i < respuesta.data.length; i++){
            //   if(respuesta.data[i].productoId == this.idProducto_tmp){
            //     idFocus=respuesta.data[i]._id;
            //     this.idFocus_config=respuesta.data[i].idSurveyConfiguration;
            //     this.tokenConfig=respuesta.data[i].tokenConfig;
            //     break;
            //   }
            // }
            // idFocus=''+idFocus;
            // this.idFocus=idFocus;
            // if(this.idFocus_config){
            //   this.noEncuesta=false;
            //   this.disableButton=false;
            //   this.mostrarTabla=true;
            //   this.getFechasFocus();
            // }
            //
            // this.cargando=true;
          }, error => {
            console.log(error);
          });
        break;
        default:  //resto de productos
          this.urlEncuestas();
        break;
      }
    } else{

    }
  }

  getProrrogasFechasCierre(datos){
    this.surveyServ.getProrrogasFechaCierre(datos).subscribe( (data: any) => {
      console.log("getProrrogasFechaCierre:",data);
      if(data.result.length > 0){
        this.setDatosDetalle(null, null, null, null, data.result[0].fecha, null, null);
        this.filtroCierreProrroga = (d: Date | null): boolean => {
          let fechaMinima: any;
          return moment(d || new Date()).format('MM/DD/YYYY') > moment(data.result[0].fecha).format('MM/DD/YYYY')
        };
        this.bloquearEnvias(moment(),data.result[0].fecha);
      }else{
        this.bloquearEnvias(moment(),this.datosDetallesProducto.fechasProducto[1].fecha);
      }
    });
  }

  bloquearEnvias(fechaActual:any, fechaCierre:any){
    let tiempo1 = moment(fechaActual);
    if(this.statusEncuesta != 2){ // Si la encuesta esta cerrada no debe entrar a estas condiciones
      if(moment(fechaCierre).isBefore(moment(fechaActual))){
        this.setStatusBoton.next({ id: 'primerosColab', status: false});
        this.setStatusBoton.next({ id: 'nuevoColab', status: false});
        this.setStatusBoton.next({ id: 'buscarColab', status: false});
        this.setStatusBoton.next({ id: 'bajarColab', status: false});
        this.setStatusBoton.next({ id: 'enviaReco', status: false});
      }
    }
  }

  obtieneIdProductoCorrecto(){
    let idProductoActual = this.productoActual.idCertificar != undefined ? this.productoActual.idCertificar : undefined;
    if(idProductoActual == undefined){
      idProductoActual = this.productoActual.idMedir != undefined ? this.productoActual.idMedir : this.productoActual.idProducto;
      if(idProductoActual == undefined){
        idProductoActual = this.productoActual.idPulseCheck != undefined ? this.productoActual.idPulseCheck : undefined;
        if(idProductoActual == undefined){
          idProductoActual = this.productoActual.idNorma35 != undefined ? this.productoActual.idNorma35 : undefined;
          if(idProductoActual == undefined){
            idProductoActual = this.productoActual._id != undefined ? this.productoActual._id : null;
          }
        }
      }
    }
    return idProductoActual;
  }

  obtieneFechaProductoCorrecta(){
    let anioProducto = this.productoActual.fechaCertificar != undefined ? this.productoActual.fechaCertificar : undefined;
    if(anioProducto == undefined){
      anioProducto = this.productoActual.fechaMedir != undefined ? this.productoActual.fechaMedir : this.productoActual.fechaProducto;
      if(anioProducto == undefined){
        anioProducto = this.productoActual.fechaPulseCheck != undefined ? this.productoActual.fechaPulseCheck : undefined;
        if(anioProducto == undefined){
          anioProducto = this.productoActual.fechaNorma35 != undefined ? this.productoActual.fechaNorma35 : undefined;
          if(anioProducto == undefined){
            anioProducto = this.productoActual.date != undefined ? this.productoActual.date : null;
          }
        }
      }
    }
    return anioProducto;
  }

  enviaDatosAcciones(){
    //envia datos generales del producto a otros componentes
    this.infoEmpresaProducto.next({
      idEmpresa: this.idEmpresa,
      idProducto: this.obtieneIdProductoCorrecto(),
      tipoProducto: this.productoActual.idProducto != undefined ? this.productoActual.idProducto : this.productoActual.idProduct,
      datosProducto: this.productoActual,
      urlEncuesta: this.datosDetallesProducto.urlEncuesta
    });
    //activa botones al componente de acciones
    this.setStatusBoton.next({ id: 'goCounting', status: false});
    this.setStatusBoton.next({ id: 'goPriv', status: false});
    this.setStatusBoton.next({ id: 'goPub', status: false});
  }

  // getBanderaUpdateFechaCierre(){
  //   let idProductoActual = this.obtieneIdProductoCorrecto();
  //   this.surveyServ.getStatusBanderaProrroga(this.idEmpresa,idProductoActual).subscribe((respuesta:any) => {
  //     console.log("getStatusBanderaProrroga:",respuesta);
  //     // this.permisoProrroga=respuesta.activarProrroga;
  //   });
  // }

  obtieneToken(){
    this.anioProducto = this.obtieneFechaProductoCorrecta();
    if(this.productoActual.idProducto != 3){  //si no es la norma 35 entra este codigo
      let token = this.productoActual.tokenConfig != undefined ? this.productoActual.tokenConfig : this.productoActual.surveyToken;
      this.getStatusEncuesta(token);
      if(this.productoActual.fechaCertificar != undefined){ //entra si un producto es certificar o 3.0
        this.getFechaLanzamiento(this.anioProducto);
      }
    }
  }

  getStatusEncuesta(token:string){
    this.surveyServ.getEstatusCierreEncuesta(token).subscribe((respuesta: any)=>{
      console.log("getEstatusCierreEncuesta:",respuesta);
      this.statusEncuesta = respuesta.result.id_status;
      if(this.statusEncuesta != 2){
        this.setStatusBoton.next({ id: 'primerosColab', status: false});
        this.setStatusBoton.next({ id: 'nuevoColab', status: false});
        this.setStatusBoton.next({ id: 'buscarColab', status: false});
        this.setStatusBoton.next({ id: 'bajarColab', status: false});
        this.setStatusBoton.next({ id: 'enviaReco', status: false});
      }
    });
  }

  getFechaLanzamiento(datos){
    let data:any = {
      productoId: this.obtieneIdProductoCorrecto()
    };
    this.surveyServ.getFechaLanzamientoStatusEncuesta(this.idEmpresa,data).subscribe((respuesta:any) => {
      console.log("respGetLanza",respuesta);
      if (respuesta.message=="200") {
        let hoy = moment();
        let fechaLanzamiento = moment(respuesta.fechaLanzamiento);
        if(hoy.isAfter(fechaLanzamiento)){
          this.setStatusBoton.next({ id: 'addPro', status: false});
          this.datosDetallesProducto.fechasProrrogas.valorDatePicker = hoy;
        } else{
          // this.setStatusBoton.next({ id: 'enviaReco', status: true});
          this.datosDetallesProducto.fechasProrrogas.valorDatePicker = fechaLanzamiento;
        }
        this.filtroLanzamiento = (d: Date | null): boolean => {
          return moment(d || new Date()).format('MM/DD/YYYY') > moment(respuesta.fechaCierre).format('MM/DD/YYYY')
        };
        this.setDatosDetalle(null, null, respuesta.fechaLanzamiento, respuesta.fechaCierre, null, null, null);
        this.infoEmpresaProducto.next({
          fechaLanzamiento: respuesta.fechaLanzamiento
        });
      }
    });
  }

  getFechaLanzamientoNorma(fechaNorma35:number){
    let dataReg: any = { fechaNorma35 };
    this.surveyServ.getFechaLanzamiento35_req(dataReg, this.idEmpresa).subscribe((response:any) => {
      console.log("getFechaLanzamiento35:",response);
      // if(response.message == "200"){
      //   this.fechaLanzamiento = response.fechaLanzamiento;
      //   this.fechaCierre = response.fechaCierre;
      //   this.disableButton=false;
      //   let fechaActual= moment();
      //   let fechaCierreProrroga= moment(this.fechaCierre);
      //   if(fechaActual.isAfter(fechaCierreProrroga)){
      //     this.diasRestantes=0;
      //   }else{
      //     this.diasRestantes=fechaCierreProrroga.diff(fechaActual,'days');
      //   }
      // }
    }, error => {
      console.log(error);
    });
  }

  getPorcentajeN35(idProducto:number, param:number){
    this.surveyServ.normaCloseSurvey(idProducto, param, this.idEmpresa).subscribe((respuesta:any) => {
      console.log("param:",param," normaCloseSurvey:",respuesta);
      // this.dataTmp2=respuesta.avance;
      // this.porcentaje2=this.dataTmp2.porcentaje;
    });
  }

  urlEncuestas(){
    let idProducto = this.productoActual.idProducto != undefined ? this.productoActual.idProducto : this.productoActual.idProduct;
    switch (idProducto) {
      case 1: case 20: case 40: case 41: case 42: case 43: //casos productos 3.0
        this.validarEncuesta();
        let datoProducto = {
          productoId: this.productoActual.idCertificar
        };
        this.surveyServ.getPilotoDataEncuesta_estatus(datoProducto,this.idEmpresa).subscribe((data: any) => {
          console.log("getPilotoData:",data);
          if(data.message = 'Success'){
            this.datosDetallesProducto.urlEncuesta = data.piloto.url
            this.infoEmpresaProducto.next({
              urlEncuesta: this.datosDetallesProducto.urlEncuesta
            });
            this.setStatusBoton.next({ id: 'goSurvey', status: false});
          }
        });
        this.surveyServ.getAvanceEncuesta(datoProducto,this.idEmpresa).subscribe((respuesta:any) => {
          console.log("getAvanceEncuesta:",respuesta);
          if(respuesta.message == 'Success'){
            this.setDatosDetalle(idProducto, this.anioProducto, null, null, null, respuesta.avance.endUsers, respuesta.avance.totalUsers);
          }
          if(this.datosDetallesProducto.fechasProducto[2].activa){
            this.bloquearEnvias(moment(),this.datosDetallesProducto.fechasProducto[2].fecha);
          } else{
            this.bloquearEnvias(moment(),this.datosDetallesProducto.fechasProducto[1].fecha);
          }
        }, error => {
          console.log(error);
        });
      break;
      case 2: case 11: case 12: case 13: case 14: case 15: case 16: //casos productos medir
        this.getUrl_medires();
        this.getAvancesMedir();
      break;
      case 4: //caso producto pulse check v1
        this.validarEncuesta();
        let dataPulse = {productoId: this.productoActual.idPulseCheck};
        this.surveyServ.getPilotoData_Pulse(dataPulse,this.idEmpresa).subscribe((response: any )=> {
          console.log("getPilotoData_Pulse:",response);
          // if(response.message = 'Success'){
          //   this.urlEncuesta=response.data[0].urlShorter;
          //   this.showUrl=true;
          //   this.cierreService.getFechasProgramacionPulse_status(dataPulse,this.idEmpresa).subscribe((respuesta: any)=>{
          //     console.log(respuesta);
          //     this.fechaLanzamiento=respuesta.data[0].fechaLanzamiento;
          //     console.log('this.fechaLanzamiento',this.fechaLanzamiento);
          //
          //     this.fechaCierre=respuesta.data[0].fechaCierre;
          //     let fechaDeCierre=respuesta.data[0].fechaCierre;
          //     let  now = new Date();
          //     console.log("fechaActual",now);
          //     let fechaDeLanzamiento=new Date(this.fechaLanzamiento);
          //     console.log("fechaLanzamientoActual",fechaDeLanzamiento);
          //
          //     if(now>fechaDeLanzamiento){
          //       this.btnProrroga=true;
          //       console.log('btnProrroga',this.btnProrroga);
          //       this.filtroLanzamiento = (d: Date | null): boolean => {
          //         let fechaMinima: any;
          //         return moment(d || new Date()).format('MM/DD/YYYY') > moment(fechaDeCierre).format('MM/DD/YYYY')
          //       };
          //       this.fechaValueProrroga=now;
          //       console.log("fecha actual es mayor a la de lanzamiento");
          //     }else{
          //       this.fechaValueProrroga=fechaDeLanzamiento;
          //       this.bloquearBotonReminder=true;
          //       localStorage.setItem("bloquear_btn","true");
          //       console.log("fecha actual no es mayor a la de lanzamiento");
          //       this.filtroLanzamiento = (d: Date | null): boolean => {
          //         let fechaMinima: any;
          //         return moment(d || new Date()).format('MM/DD/YYYY') > moment(fechaDeCierre).format('MM/DD/YYYY')
          //       };
          //     }
          //     this.disableButton=false;
          //     this.getAvancesPulse();
          //   });
          // }
        }, error => {
          console.log(error);
        });
      break;
      case 52:  //cgo express
        this.validarEncuesta();
        let datoCgoEXP = {
          productoId: this.productoActual._id
        };
        this.surveyServ.getPilotoDataEncuesta_estatus(datoCgoEXP,this.idEmpresa).subscribe((data: any) => {
          console.log("getPilotoData:",data);
          if(data.message = 'Success'){
            this.datosDetallesProducto.urlEncuesta = data.piloto.url
            this.infoEmpresaProducto.next({
              urlEncuesta: this.datosDetallesProducto.urlEncuesta
            });
            this.setStatusBoton.next({ id: 'goSurvey', status: false});
          }
        });
        this.surveyServ.getAvanceEncuesta(datoCgoEXP,this.idEmpresa).subscribe((response:any) => {
          console.log("getAvanceEncuesta:",response);
          if(response.message == 'Success'){
            let cgoEx = this.productoActual;
            this.setDatosDetalle(cgoEx.idProduct, cgoEx.date, cgoEx.programming.launchDate, cgoEx.programming.closeDate, null, response.avance.endUsers, response.avance.totalUsers);
          }
        }, error => {
          console.log(error);
        });
      break;
    }
  }

  validarEncuesta(){
    let token = this.productoActual.tokenConfig != undefined ? this.productoActual.tokenConfig : this.productoActual.surveyToken;
    if(token){
      this.surveyServ.surveyCheck(token).subscribe((respuesta:any) => {
        console.log("surveyCheck:",respuesta);
        if(respuesta.success){
          this.infoSurveyCheck.next(respuesta.result);
          this.setStatusBoton.next({ id: 'surveyCheck', status: false});
          if(respuesta.result.length == 0){
            this.encuestaActiva = true;
          } else{
            if(respuesta.result[1].value == '0'){
              this.encuestaActiva = false;
            } else{
              this.encuestaActiva = true;
            }
          }
          this.enviaDatosAcciones();
        }
      }, error => {
        console.log("Survey check services error");
        console.log(error);
      });
    }
  }

  getUrl_medires(){
    let dataMedir = {
      productoId : this.productoActual.idMedir != undefined ? this.productoActual.idMedir : this.productoActual.idProducto
    };
    this.surveyServ.getPilotoData_medir(dataMedir,this.idEmpresa).subscribe( (response: any) => {
      console.log("getPilotoData_medir:",response);
      // if(response.message = 'Success'){
      //   this.urlEncuesta=response.piloto.url;
      //   this.showUrl=true;
      // }
    });
  }
  getAvancesMedir(){
    let data={
      productoId: this.productoActual.idMedir != undefined ? this.productoActual.idMedir : this.productoActual.idProducto
    };
    this.surveyServ.getAvanceEncuestaMedir(data,this.idEmpresa).subscribe((response:any) => {
      console.log("getAvanceEncuestaMedir:",response);
      // this.fechaLanzamiento=response['fechaLanzamiento'];
      // let  now = new Date();
      // let fechaDeLanzamiento=new Date(this.fechaLanzamiento);
      // if(now<fechaDeLanzamiento){
      //   this.bloquearBotonReminder=true;
      //   localStorage.setItem("bloquear_btn","true");
      // }
      // this.disableButton=false;
      // if(response['message'] == 'Success'){
      //   this.fechaCierre=response['fechaCierre'];
      //   this.porcentaje = +response['avance']['porcentaje'];
      // }
      // let fechaActual= moment();
      // let fechaCierre= moment(this.fechaCierre);
      // if(fechaActual.isAfter(fechaCierre)){
      //   this.diasRestantes=0;
      //   console.log(this.diasRestantes);
      // }else{
      //   this.diasRestantes=fechaCierre.diff(fechaActual,'days');
      //   console.log(this.diasRestantes);
      // }
    }, error => {
      console.log("Estatus cierre encuesta");
      console.log(error);
    });
  }

}
